import React, { useContext, useEffect, useRef, useState } from 'react'
import { store } from '../../stores/pages'
import { Button, Col, FormGroup, Input, InputGroup, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import Pusher from 'pusher-js'
import { Clipboard } from 'react-feather'
import { CopyToClipboard } from 'react-copy-to-clipboard'

export default function Publish() {
  const {
    viewingContentEditor,
    page,
    publishing,
    pusherAppKey,
    teamChannel,
    pusherCluster,
    cancelLink,
    unpublishing,
    actions,
    dispatch,
  } = useContext(store)

  const [title, setTitle] = useState(page.attributes.title)
  const [description, setDescription] = useState(page.attributes.description)

  const publishingRef = useRef(publishing)
  const pageRef = useRef(page)
  const [copyText, setCopyText] = useState("Copy")

  const setCopiedText = () => {
    setCopyText("Copied!")
    setTimeout(() => {
      setCopyText("Copy")
    }, 3000)
  }

  useEffect(() => {
    publishingRef.current = publishing
  }, [publishing])

  useEffect(() => {
    pageRef.current = page
  }, [page])

  const handlePublish = () => {
    dispatch({ type: actions.START_PUBLISHING})
  }

  const handleUnpublish = () => {
    dispatch({ type: actions.UNPUBLISH_PAGE })
  }

  const handleContinueEditing = () => {
    dispatch({ type: actions.SET_PUBLISHING, payload: false })
  }

  useEffect(() => {
    const socket = new Pusher(pusherAppKey, {
      cluster: pusherCluster,
    })
    socket.subscribe(teamChannel).bind(`automatedPreview`, (data) => {
      if (data.data.id == pageRef.current.id && publishingRef.current == 'generating' && !data.data.attributes.generating) {
        dispatch({
          type: actions.PUBLISH_PAGE,
          page: data.data,
        })
      }
    })
  }, [])

  return (
    <div className={`producer-form-container ${viewingContentEditor && 'd-none'}`}>
      <FormGroup>
        <Label>Page Title</Label>
        <Input
          type="text"
          name="title"
          value={title}
          placeholder="Enter page title"
          onChange={(e) => setTitle(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label>Description</Label>
        <Input
          type="textarea"
          name="description"
          rows="3"
          value={description}
          placeholder="A brief description of the content of the page"
          onChange={(e) => setDescription(e.target.value)}
        />
      </FormGroup>
      {page.attributes.published ? (
        <>
          <FormGroup>
            <Label>Page URL</Label>
            <InputGroup>
              <Input type="text" value={page.attributes.url} readonly />
              <CopyToClipboard
                text={page.attributes.url}
                onCopy={setCopiedText}
              >
                <Button color="outline-secondary">
                  <Clipboard size="16" className="me-1 icon-valign" />{" "}
                  {copyText}
                </Button>
              </CopyToClipboard>
            </InputGroup>
            <small className="text-muted d-block mt-1">Published {new Date(page.attributes.published_at).toLocaleString()}</small>
          </FormGroup>
          <Row>
            <Col className="pe-0">
              <Button href={page.attributes.url} color="primary" className="w-100">
                Visit Page
              </Button>
            </Col>
            <Col>
              <Button color="outline-secondary" className="w-100" onClick={handleUnpublish} disabled={unpublishing}>
                {unpublishing ? 'Unpublishing...' : 'Unpublish'}
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        <Button className="w-100" color="primary" onClick={handlePublish} disabled={!!publishing}>
          Publish this Page
        </Button>
      )}
      <Modal size="md" isOpen={!!publishing}>
        <ModalHeader
          className="modal-header-segmented d-flex align-items-center"
          tag="div"
        >
          <h2 className="fst-normal fs-5 m-0">
            {publishing != 'published' ? 'Publishing' : 'Published!'}
          </h2>
        </ModalHeader>
        <ModalBody>
          {publishing == 'published' ? (
            <>
              <FormGroup>
                <Label>Page URL</Label>
                <InputGroup>
                  <Input type="text" value={page.attributes.url} readonly />
                  <CopyToClipboard
                    text={page.attributes.url}
                    onCopy={setCopiedText}
                  >
                    <Button color="outline-secondary">
                      <Clipboard size="16" className="me-1 icon-valign" />{" "}
                      {copyText}
                    </Button>
                  </CopyToClipboard>
                </InputGroup>
              </FormGroup>
              <Button href={page.attributes.url} color="primary" className="w-100">
                Visit Page
              </Button>
              <Row className="mt-3">
                <Col className="pe-0">
                  <Button href={cancelLink} color="outline-secondary" className="w-100">
                    Back to Pages
                  </Button>
                </Col>
                <Col>
                  <Button onClick={handleContinueEditing} color="outline-secondary" className="w-100">
                    Continue Editing
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <div className="text-center">
              <div className="spinner mt-4"></div>
              <p className="text-muted mt-2">
                {publishing == 'saving' && 'Saving...'}
                {publishing == 'generating' && 'Generating Preview...'}
                {publishing == 'publishing' && 'Publishing...'}
              </p>
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}
